import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { ControlsPosition } from "@omni/types/components/props/productSlider.props";
import { LayoutSettings } from "@omni/types/packages/swiper.types";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { ProductSliderDefault } from "@/components/Product/ProductSlider/productSlider.default";

type AccessoriesSliderProps = {
    sku: string;
    serverSideProducts?: Array<Product<ProductFieldSet.ProductTile>>;
    productSource:
        | ProductSliderSources.MainProduct
        | ProductSliderSources.Accessory;
    title: string;
    breakpointsLayoutSettings: LayoutSettings;
};

const RelatedProductsSliderComponent = ({
    sku,
    serverSideProducts,
    productSource,
    title,
    breakpointsLayoutSettings
}: AccessoriesSliderProps) => {
    return (
        <section>
            <Row>
                <Col>
                    <div>
                        <ProductSliderDefault
                            title={title}
                            controlsPosition={ControlsPosition.Default}
                            sku={sku}
                            source={productSource}
                            productTileConfig={{
                                amountOfFeatures: 0,
                                useInsidePadding: false,
                                showButton: false,
                                showCategoryLink: false,
                                allowInstantAddToCart: false
                            }}
                            breakpointsConfig={{
                                hidden: [],
                                layoutSettings: breakpointsLayoutSettings
                            }}
                            serverSideProducts={serverSideProducts}
                        />
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export { RelatedProductsSliderComponent };
